import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import { BillingPlanId } from '@/modules/billing/constants/BillingPlanId';

export class VaultPlanType extends Enum {
  key!: string;
  value!: string;
  billingPlanId?: string;

  static CUSTOM: VaultPlanType = {
    key: 'custom',
    billingPlanId: BillingPlanId.INDIVIDUAL_CUSTOM,
    get value(): string {
      return '';
    }
  };

  static STANDARD: VaultPlanType = {
    key: 'standard',
    billingPlanId: BillingPlanId.INDIVIDUAL_STANDARD_PLAN,
    get value(): string {
      return Lang.t('standardplan.standard');
    }
  };

  static BASIC: VaultPlanType = {
    key: 'basic',
    billingPlanId: BillingPlanId.INDIVIDUAL_BASIC_PLAN,
    get value(): string {
      return Lang.t('standardplan.basic');
    }
  };

  static COMPLETE: VaultPlanType = {
    key: 'complete',
    billingPlanId: BillingPlanId.INDIVIDUAL_COMPLETE_PLAN,
    get value(): string {
      return Lang.t('standardplan.complete');
    }
  };

  static PROFESSIONAL: VaultPlanType = {
    key: 'professional',
    billingPlanId: BillingPlanId.INDIVIDUAL_PROFESSIONAL_EXECUTOR,
    get value(): string {
      return Lang.t('standardplan.professional');
    }
  };

  static DIGITAL_VAULT: VaultPlanType = {
    key: 'digital_vault',
    billingPlanId: BillingPlanId.INDIVIDUAL_DIGITAL_VAULT,
    get value(): string {
      return Lang.t('billingplan.digital-vault');
    }
  };

  static isSelfServe(key: string): boolean {
    return [VaultPlanType.STANDARD.key, VaultPlanType.BASIC.key].includes(key);
  }
}
